import React, { useEffect, useState } from 'react'
import styles from '../styles/newFeature.module.css';
import Image from 'next/image';
import ReactTyped from 'react-typed';
import { ComparisionSection, HeroSection, MarqueeComponentHomePage, StackContainers, StackSkeleton, WhiteCustomButton } from '@/components/qbStrap';
import { ClientsArr1, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import content from '../language/ENGLISH.json'
import TestimonialSection from '@/components/common/TestimonialSection';
import PersonalisedDemoBanner from '@/components/common/PersonalisedDemoBanner';
import FrequentQuestions from '@/components/homePage/FrequentQuestions';
import VerificationPopup from '@/components/modals/VerificationPopup';
import ThreeStepForm from '@/components/common/ThreeStepForm';
import { OurPartners } from './homePage/OurPartners';
import { MobileOurPartners } from './homePage/MobileOurPartners';
import FAQ_mobile from './Industry/FAQ_mobile';
import MobileTestimonialSection from './common/MobileTestimonialSection';
import MobilePDBanner from './common/MobilePDBanner';

const Einvoicing = () => {
    const { commonMarqueTitle } = getTitleContent();
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const features = [
        {
            id: 1,
            title: "Complete e-invoicing Software for Tax Experts",
            desc: "QueueBuster, as a recognized GST Suvidha Provider (GSP), simplifies the invoicing process for tax professionals by allowing direct uploads to the IRP without relying on third-party platforms. This significantly reduces the complexity and cost associated with managing multiple platforms for e-invoicing.",
            point: [
                <> <b>Direct IRP Upload:</b> Bypass the need for third-party GSPs with QueueBuster’s direct integration to the IRP, making your invoicing process quicker and more cost-effective.</>,
                <> <b>Real-Time Validation:</b> Automatically validate invoice details to avoid errors before submission, ensuring compliance with GST rules.</>,
                <> <b>Comprehensive Reporting:</b> Access detailed reports that track the status of your invoices, validation trends, and potential compliance issues, all in one place.</>
            ],
            image: "/assets/features/e-invoicing/tax-experts.webp",
            stack3Clr: "#fff6e1",
            stack2Clr: "#FFE9B6",
            stack1Clr: "#ffe097",
            imgHeight: "42rem",
            mobImgHeight: "24rem",
            borderColor: "#ffba00",
            ptContainerHeight: "6rem",
            mobPtContainerHeight: "7rem"
        },
        {
            id: 2,
            title: "Robust e-Invoicing for SME’s",
            desc: "QueueBuster GST E-Invoicing Solution provides SMEs with an intuitive, efficient, and compliant way to handle their invoicing requirements. By automating validation checks, businesses can avoid common errors and ensure their invoices are fully compliant with GST laws.",
            point: [
                <><b>Automated Data Validation:</b> QueueBuster proactively checks for any missing fields, incorrect entries, or violations of GST norms before invoice submission, ensuring smooth compliance.</>,
                <><b>Instant Notifications:</b> Receive alerts in real-time if there are validation issues, allowing you to resolve them quickly and prevent the submission of faulty invoices.</>,
                <><b>Customized for Your Business:</b> Tailor validation criteria and reporting to suit your specific business needs, helping you identify and address recurring issues efficiently.</>
            ],
            image: "/assets/features/e-invoicing/SME.webp",
            stack3Clr: "#E2FBFF",
            stack2Clr: "#C2F7FF",
            stack1Clr: "#A1F3FF",
            imgHeight: "52rem",
            mobImgHeight: "30rem",
            borderColor: "#8AE4F6",
            ptContainerHeight: "6rem",
            mobPtContainerHeight: "7rem"
        }
    ]

    const whyQBeWayBill = [
        {
            id: 1,
            title: "Customizable Invoice Templates",
            desc: " Easily create invoices that meet GST requirements while maintaining your brand’s identity. Personalize invoices with your company’s colors and design elements to enhance your professional image."
        },
        {
            id: 2,
            title: "Real-Time Dashboard",
            desc: "Stay informed with a real-time view of your sales, expenses, and GST liabilities. Make informed decisions based on accurate, up-to-date data that helps you manage cash flow and tax obligations."
        },
        {
            id: 3,
            title: "Bulk Invoice Upload (Coming Soon)",
            desc: "Save time by uploading multiple invoices at once, streamlining the invoicing process and reducing the likelihood of manual errors. This upcoming feature will further enhance productivity for businesses dealing with large volumes of invoices."
        },
        {
            id: 4,
            title: "Secure Data Storage",
            desc: "Protect your financial data with encryption and automatic backups. QueueBuster ensures that your invoices and financial records are stored securely, giving you peace of mind that your information is safe from breaches or data loss."
        },
        {
            id: 5,
            title: "Seamless Integrations",
            desc: "Effortlessly integrate QueueBuster with your existing business applications and accounting software, including Tally, Zoho Books, and other industry-standard platforms. This ensures your invoicing process fits smoothly into your current workflow without disruptions."
        },
        {
            id: 6,
            title: "Dedicated Support",
            desc: "Get personalized assistance from our team of experts. Whether you need help with setup, workflow optimization, or troubleshooting, our dedicated support ensures a smooth e-invoicing experience."
        },
    ]

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    Which is the best software for e-invoicing?
                </span>
            ),
            des: "The best e-invoicing software depends on the specific needs of your business. Popular options include Tally, Zoho Invoice, QuickBooks, and SAP Concur. These platforms offer comprehensive features like seamless integration with accounting systems, real-time invoice tracking, and compliance with GST regulations. Tally is widely used in India for its robust GST functionalities, while Zoho Invoice is known for its user-friendly interface and customization options. QuickBooks is excellent for small to medium-sized businesses due to its extensive financial management features, and SAP Concur caters to larger enterprises with advanced expense management and automation capabilities.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Is e-invoicing free?
                </span>
            ),
            des: "E-invoicing is not typically free. Most software solutions charge a subscription fee based on the number of invoices processed, the level of features required, and the size of the business. Some platforms offer free basic versions with limited functionalities, while advanced features and higher volumes of invoicing usually come at a cost. However, the investment in e-invoicing software can lead to significant savings in administrative costs, reduce errors, and improve compliance, making it a valuable investment for businesses.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How to generate an e-invoice with software?
                </span>
            ),
            des: <>
                To generate an e-invoice using software, follow these steps:
                <ol>
                    <li>Set Up Your Account: Register with an e-invoicing software provider and configure your account with your business details.</li>
                    <li>Integrate with Accounting System: Ensure the software integrates with your existing accounting or ERP system to streamline data flow.</li>
                    <li>Enter Invoice Details: Input the necessary details such as buyer information, product or service description, quantity, price, and tax rates.</li>
                    <li>Generate the Invoice: Use the software to create the invoice. The system will generate an Invoice Reference Number (IRN) and QR code, as required by GST regulations.</li>
                    <li>Submit to IRP: The software will submit the invoice to the Invoice Registration Portal (IRP) for validation.</li>
                    <li>Receive IRN and QR Code: Once validated, the IRP will return the IRN and a digitally signed QR code, which should be included in the final invoice.</li>
                    <li>Send to Buyer: The final e-invoice can be sent to the buyer via email or other digital means.</li>
                </ol>
            </>,
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is the limit for an e-invoice?
                </span>
            ),
            des: "As of the latest regulations, e-invoicing is mandatory for businesses with an annual turnover exceeding ₹10 crore. This threshold has been gradually lowered over time to include more businesses. It's important to stay updated with the latest government notifications as these limits can change. There is no limit on the number of e-invoices a business can generate; the requirement is based solely on the annual turnover threshold.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How many types of e-invoices are there?
                </span>
            ),
            des: <>
                E-invoicing systems can generally be categorized into a few types:
                <ol>
                    <li>Business-to-Business (B2B): Invoices exchanged between businesses for the supply of goods or services.</li>
                    <li>Business-to-Government (B2G): Invoices generated for transactions with government entities.</li>
                    <li>Business-to-Consumer (B2C): Although not always mandatory, some businesses generate e-invoices for consumer transactions to streamline processes and maintain records.</li>
                    <li>Export Invoices: Specific e-invoices generated for goods or services exported outside the country.</li>
                </ol>
                Each type may have specific regulatory requirements and formats that businesses need to adhere to.
            </>,
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How to start e-invoicing?
                </span>
            ),
            des: <>
                To start e-invoicing, follow these steps:
                <ol>
                    <li>Assess Requirements: Determine if your business falls under the mandatory e-invoicing threshold based on annual turnover.</li>
                    <li>Select Software: Choose an e-invoicing software that meets your business needs and complies with GST regulations.</li>
                    <li> Register on the IRP: Ensure your business is registered on the Invoice Registration Portal (IRP) provided by the government.</li>
                    <li>Integrate Systems: Integrate the chosen software with your existing accounting or ERP system for seamless data flow.</li>
                    <li>Train Staff: Train your accounting and finance team on using the e-invoicing software.</li>
                    <li>Generate and Submit: Start generating e-invoices and submitting them to the IRP for validation and obtaining the IRN and QR code.</li>
                </ol>
            </>,
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Is an e-Way bill mandatory for an e-invoice?
                </span>
            ),
            des: "An e-Way bill is not always mandatory for every e-invoice. However, it is required when the movement of goods exceeds ₹50,000 in value. The Eway bill is used to track the movement of goods and ensures compliance with GST regulations. When generating an e-invoice, the software can typically also generate an Eway bill if the transaction meets the criteria, ensuring seamless compliance.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is e-billing software?
                </span>
            ),
            des: "E-billing software is a digital tool that automates the creation, distribution, and management of invoices. It helps businesses streamline their billing processes, ensuring accuracy and compliance with tax regulations. Key features include generating electronic invoices, automating payment reminders, integrating with accounting systems, and providing real-time tracking of invoice status. E-billing software enhances efficiency, reduces manual errors, and ensures timely payments, benefiting both businesses and their clients.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is the 7-day time limit for e-invoice?
                </span>
            ),
            des: "The 7-day time limit refers to the window within which an e-invoice must be reported to the IRP for validation. This ensures that invoices are timely and accurately recorded in the GST system. Delays beyond this period may result in non-compliance and potential penalties. Therefore, businesses must generate and submit their e-invoices promptly to stay within the regulatory timeframe.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Which software/app is used to bill?
                </span>
            ),
            des: "Several software and apps can be used for billing, depending on your business needs. Popular options include Tally, Zoho Invoice, QuickBooks, and SAP Concur. These platforms offer a range of features such as invoice generation, expense tracking, GST compliance, and integration with other financial systems. They are designed to simplify billing processes, enhance accuracy, and ensure timely payments.",
            id: 10,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How to process an e-bill?
                </span>
            ),
            des: <>
                To process an e-bill:
                <ol>
                    <li>Generate the Bill: Use e-billing software to create the bill, entering all necessary details like customer information, items or services, quantities, and prices.</li>
                    <li>Submit for Validation: If required by regulations, submit the bill to the relevant government portal (such as the IRP for GST) for validation and obtaining necessary references like IRN.</li>
                    <li>Deliver to Customer: Send the validated e-bill to the customer via email or other digital means, including all necessary references like QR codes.</li>
                    <li>Record Payment: Track and record the payment status using the e-billing software, sending reminders if payments are delayed.</li>
                    <li>Update Records: Ensure that all financial records are updated in your accounting system to reflect the transaction.</li>
                </ol>
            </>,
            id: 11,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is E-Invoicing and How Does it Work?
                </span>
            ),
            des: "E-invoicing is the electronic generation, validation, and exchange of invoices between businesses and their customers through a standardized digital format. It involves creating an invoice using e-invoicing software, which is then validated by the government’s IRP. The validated invoice receives an IRN and a QR code, ensuring its authenticity and compliance with tax regulations. This e-invoice is then shared with the customer and recorded in the business's accounting system. E-invoicing reduces errors, enhances transparency, and streamlines tax reporting.",
            id: 12,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is The Difference Between Invoice and E-Invoice?
                </span>
            ),
            des: "An invoice is a document issued by a seller to a buyer detailing the goods or services provided and the amount due. It can be in paper or digital format. An e-invoice, on the other hand, is a standardized electronic version of an invoice that is generated, validated, and exchanged through digital means, complying with specific regulatory requirements. E-invoices include unique identifiers like IRN and QR codes, ensuring authenticity and facilitating easier tax reporting and compliance.",
            id: 13,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is the Applicability of E-Invoicing?
                </span>
            ),
            des: "E-invoicing applies to businesses with an annual turnover exceeding a certain threshold, currently set at ₹10 crore. It is mandatory for B2B transactions and for specific types of transactions like exports. The applicability can vary based on government regulations, which aim to increase transparency, reduce tax evasion, and streamline the GST system. Businesses below the threshold can still use e-invoicing voluntarily to benefit from its efficiencies.",
            id: 14,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is the E-Invoice Registration Portal (IRP)?
                </span>
            ),
            des: "The E-Invoice Registration Portal (IRP) is a government platform where businesses submit their invoices for validation under the e-invoicing system. The IRP verifies the invoice details, generates an Invoice Reference Number (IRN), and provides a digitally signed QR code. This validated invoice is then used for GST reporting and compliance. The IRP ensures the authenticity of invoices and helps in maintaining a standardized invoicing system.",
            id: 15,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is an Invoice Reference Number (IRN)?
                </span>
            ),
            des: "An Invoice Reference Number (IRN) is a unique identifier generated by the IRP for each validated e-invoice. It ensures the invoice's authenticity and helps in tracking the invoice within the GST system. The IRN is included in the final e-invoice along with a QR code, providing a secure and verifiable reference for the transaction. It is crucial for compliance and audit purposes.",
            id: 16,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Is it Mandatory to Generate The IRN?
                </span>
            ),
            des: <>Yes, generating the IRN is mandatory for businesses that fall under the e-invoicing threshold as per GST regulations. The IRN ensures the invoice is validated and authenticated by the government’s IRP. Without the IRN, the e-invoice is not considered valid for GST reporting and compliance, which could lead to penalties and other legal issues. <br />QueueBuster is a comprehensive invoicing software that offers a range of features to simplify your invoicing and accounting processes. The software also provides a real-time dashboard that displays the status of your invoices, giving you a quick overview of your financial activities. You can save time and effort by uploading multiple invoices at once using the bulk upload feature. <br /> <br />QueueBuster stores your data in a secure, encrypted environment, ensuring the confidentiality and privacy of your sensitive information. Additionally, the software integrates seamlessly with popular accounting and ERP software, such as Tally, SAP, and Oracle, to streamline your invoicing and accounting processes. Finally, QueueBuster is multi-device compatible, allowing you to access it from any device, including desktops, laptops, tablets, and smartphones, making it easy to manage your invoices on the go.</>,
            id: 17,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is e-invoicing, and why is it mandatory for businesses with a turnover exceeding ₹5 crore?
                </span>
            ),
            des: "E-invoicing stands for electronic invoicing, a digital method of generating and exchanging invoices between businesses and their clients. The Government mandates businesses with a turnover surpassing ₹5 crore to adopt e-invoicing from August 1, 2023, for enhanced transparency and efficiency in the taxation system.",
            id: 18,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster simplify the e-invoicing process for businesses?
                </span>
            ),
            des: "QueueBuster, as a GST Suvidha Provider, offers a direct invoice uploading feature to the Invoice Registration Portal (IRP), eliminating the need for an additional GSP. This ensures a streamlined and efficient e-invoicing experience.",
            id: 19,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can I customize validation criteria in QueueBuster E-Invoicing Solution to match my business requirements?
                </span>
            ),
            des: "Yes, you can tailor validation criteria to align with your specific business needs. This enhances adaptability to different industries and workflows, ensuring accurate and compliant data submissions.",
            id: 20,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What benefits do recurring e-invoices offer, and how can businesses set them up with QueueBuster?
                </span>
            ),
            des: "Recurring e-invoices provide hassle-free invoicing by automating the charging process. QueueBuster allows businesses to customize the frequency and timing of recurring invoices, ensuring flexibility in billing cycles.",
            id: 21,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster support businesses with multiple GSTINs?
                </span>
            ),
            des: "QueueBuster supports multiple GSTINs by providing a centralized dashboard that consolidates data from various branches. Users can generate individual reports for each branch, switch between GSTINs seamlessly, and gain comprehensive insights into transactions across all entities.",
            id: 22,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can businesses connect to the IRP using QueueBuster's REST APIs, and what security measures are in place?
                </span>
            ),
            des: "Yes, businesses can effortlessly connect to the IRP and push e-invoices using QueueBuster's robust REST APIs. The system ensures data security through encryption measures, safeguarding sensitive information transmitted through the APIs.",
            id: 23,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What additional features does QueueBuster E-Invoicing Software offer?
                </span>
            ),
            des: "QueueBuster is a comprehensive invoicing solution with features such as customizable templates, a real-time dashboard for quick overviews, bulk upload functionality, secure data storage, seamless integrations with popular accounting software, and multi-device compatibility for on-the-go management.",
            id: 24,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster handle validation trends over time, and why is this feature beneficial for businesses?
                </span>
            ),
            des: "QueueBuster provides detailed reports on validation trends over time, empowering businesses to identify and address recurring issues. This continuous improvement approach ensures that businesses can maintain accuracy and compliance in their e-invoicing processes.",
            id: 25,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Is QueueBuster suitable for businesses experiencing growth and expansion?
                </span>
            ),
            des: "Absolutely. QueueBuster is designed with scalability in mind, making it a reliable solution for businesses undergoing expansion. The software adapts to the evolving needs of growing enterprises while ensuring efficient e-invoicing practices.",
            id: 19,
            activeIndex: 0,
        },
    ]

    const eWayBill = {
        stack1Clr: "#E3B8FD",
        stack2Clr: "#EFD5FF",
        stack3Clr: "#FCF7FF",
        content: <div className={styles.whyQBeWayBill}>
            <h4>Why Use QueueBuster e-Invoicing Software?</h4>
            <ul>
                {
                    whyQBeWayBill.map((ele) => {
                        return (
                            <li style={{ borderColor: "#E3B8FD" }}>
                                <h5>{ele.title}</h5>
                                <p>{ele.desc}</p>
                            </li>
                        )
                    })
                }
            </ul>
            <div className={styles.harwdare_device}><Image src="/assets/hardware/APOS.webp" alt="hardware device" fill /></div>
        </div>
    }

    const [heroReadMore, setHeroReadMore] = useState(false);

    return (
        <div>
            <div className={styles.verificationPopupOverride}>
            <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            {
                mobileView ?
                    <div className={styles.hero_section} style={{ backgroundImage: "url('/assets/features/e-invoicing/mobile-hero-img.webp')" }}>
                        <div>
                            <h1>
                                <span>Complete<br/> E-Invoicing Software</span><br />
                                <span><ReactTyped strings={["Empowering Stockists", "Franchise Businesses", "Large Enterprises"]} typeSpeed={200} loop /></span>
                            </h1>
                            <p style={{ maxHeight: heroReadMore ? "20rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s",  marginTop: "2rem" }}>To comply with CBIC's mandate for businesses with a turnover exceeding ₹5 crore to initiate e-invoicing by August 1, 2023, it's crucial to adopt software that aligns with e-invoicing standards. QueueBuster GST E-Invoicing Solution is a compliant choice, specifically crafted to fulfill all GST requirements and facilitate a seamless transition to e-invoicing.</p>
                            <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
                            <div className={styles.btn_container}>
                                <button className={styles.solid_btn}>Try It Free</button>
                                <button className={styles.border_btn}>Contact Sales</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.sections}>
                        <HeroSection
                            style={{ font: "normal normal bold 4.3rem/5.5rem Inter", color: "#fff" }}
                            backgroundImg="/assets/features/e-invoicing/hero-img.webp"
                            heading={<>Complete<br/> E-Invoicing Software</>}
                            typedHeading={["Empowering Stockists", "Franchise Businesses", "Large Enterprises"]}
                            description={"To comply with CBIC's mandate for businesses with a turnover exceeding ₹5 crore to initiate e-invoicing by August 1, 2023, it's crucial to adopt software that aligns with e-invoicing standards. QueueBuster GST E-Invoicing Solution is a compliant choice, specifically crafted to fulfill all GST requirements and facilitate a seamless transition to e-invoicing."}
                            outlinedBtn={true}
                        />
                    </div>
            }

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.cards_section}>
                {features?.map((ele) => <StackContainers ele={ele} setDemoModal={setDemoModal} setHeading={setHeading} mobileView={mobileView} />)}
            </div>

            <div style={{ margin: "10rem 0" }}><StackSkeleton ele={eWayBill} /></div>

            {
                mobileView ? <MobileOurPartners title={"Partners and Integrations"} /> : <OurPartners title={"Partners and Integrations"} />
            }

            <div className={styles.three_step_form}>
                <ThreeStepForm mobileView={mobileView} />
            </div>

            <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>

            <div style={{ marginTop: "6rem" }}>
                {
                    mobileView ?
                        <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"FAQs of QB E-Invoicing Software"} />
                        :
                        <FrequentQuestions FaqTableData={faqs} heading={"FAQs of QB E-Invoicing Software"} />
                }
            </div>

            <div className={styles.demo_banner_section}>
                {
                    mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
                }
            </div>
        </div>
    )
}

export default Einvoicing